import axiosApiPostV2 from "./axiosApiMethod";
import {busAlert} from "../main";
import router from "./index";
export function inventuryBarcode(barcode, url)
{
    var barcodeInventury = barcode;


    // inventury/detail/19/regal/6/parkovaci-pozice/421
    if (url.length == 7 && url[0] == 'inventury' && url[1] == 'detail' && url[2] > 0 && url[5] == 'parkovaci-pozice')
    {

    }
    else if (url[0] == 'inventury' && url[1] == 'detail' && url[2] > 0)
    {
        if (barcode.akcni_cislo == 1)
        {
            nactiParkovaciPozici(barcodeInventury, url);
        }
        else if (barcode.akcni_cislo == 2)
        {
            nactiParkovaciPoziciPresPolozku(barcodeInventury, url);
        }
    }
    else if (url[0] == 'inventury')
    {
        busAlert.$emit('alertMessage', {text: 'Aby bylo možné pokračovat, je potřeba nejprve vybrat inventuru.', color: 'danger', autoHide: 0, strong: 'Nejprve vyberte inventuru!'})
        $.playSound(require('@/assets/sounds/cancel.mp3'));
    }

    function nactiParkovaciPozici(barcode, url)
    {
        if (barcode.id_parkovaci_pozice > 0)
        {
            let idInventury = url[2];
            axiosApiPostV2('detail-parkovaci-pozice', {'id_parkovaci_pozice': barcode.id_parkovaci_pozice}, 'detail').then( result => {
                if (result.id_pozice_regalu == barcode.id_parkovaci_pozice)
                {
                    router.push('/inventury/detail/' + idInventury + '/regal/' + result.id_regalu + '/parkovaci-pozice/' + result.id_pozice_regalu);
                    location.reload();
                }
                else
                {
                    busAlert.$emit('alertMessage', {text: 'Nepovedlo se načíst regálovou pozici - zkuste znovu.', color: 'danger', autoHide: 0, strong: 'Parkovací pozice nenalezena!'})
                    $.playSound(require('@/assets/sounds/cancel.mp3'));
                }
            });
        }
        else
        {
            busAlert.$emit('alertMessage', {text: 'Nepovedlo se načíst regálovou pozici - zkuste znovu.', color: 'danger', autoHide: 0, strong: 'Parkovací pozice nenalezena!'})
            $.playSound(require('@/assets/sounds/cancel.mp3'));
        }
    }

    function nactiParkovaciPoziciPresPolozku(barcode, url)
    {
        let idInventury = url[2];
        axiosApiPostV2('get-inventury-pozice-polozky', {'id_pol_nd_polozky': barcode.id_pol_nd_polozky}, 'data').then( result => {
            if (result.id_regalu > 0 && result.id_pozice_regalu > 0)
            {
                $.playSound(require('@/assets/sounds/info_alert.mp3'));
                busAlert.$emit('alertMessage', {text: 'Úspěšně jste přešli na detail parkovací pozice.', color: 'info', autoHide: 3, strong: 'Detail parkovací pozice!'})
                router.push('/inventury/detail/' + idInventury + '/regal/' + result.id_regalu + '/parkovaci-pozice/' + result.id_pozice_regalu);
                location.reload();
            }
        });
    }

}